import React from "react";

import css from "./custom-div-table.module.css";

const CustomDivTableActions = ({ children }) => {
  return <div className={css.actions}>{children}</div>;
};

export default CustomDivTableActions;
